import {
  Component,
  OnInit,
  Optional,
  Inject,
  HostListener,
} from '@angular/core';
import { QuickQuoteService } from '../../services/quickquote-service.service';
import {
  PershingTranslationService,
  AppDataStore,
  PermissionCheckerService,
  PershingDecimalFormatPipe,
} from '@pershing/pershing-core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import moment_ from 'moment-timezone';
const moment = moment_;
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialog as MatDialog,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { lastValueFrom, Subject, takeUntil } from 'rxjs';
import { QuoteToggleService } from '@pershing/nxi-ng-quotetoggle';

@Component({
  selector: 'quick-quote-dialog',
  templateUrl: './quick-quote-dialog.component.html',
})
export class QuickQuoteCardComponent implements OnInit {
  quoteData: any = null;
  hasAgreed: boolean = false;
  showLink: boolean = false;
  showRealTimeToggle: boolean = false;
  showFullQuote: boolean = false;
  fullQuoteUrl: string;
  tradeUrl: string;
  symbol: string;
  isAdvisor: boolean = false;
  queryParam: Params;
  isRealTimePref: boolean = false;
  displayRealtime: boolean = false;
  invalidSymbol: boolean = false;
  sysDate: Date = new Date();
  chartImage: boolean = true;
  disclaimerState = false;
  unsubscribe: Subject<void> = new Subject<void>();
  quoteType: string = 'D';
  showDisclaimers: boolean = true;
  displayTradeButton: boolean = true;

  constructor(
    public QuickQuoteService: QuickQuoteService,
    private translationService: PershingTranslationService,
    private appStore: AppDataStore,
    private authService: PermissionCheckerService,
    public pershingDecimalFormatingPipe: PershingDecimalFormatPipe,
    private quoteToggleService: QuoteToggleService,
    @Optional() private route: ActivatedRoute,
    @Optional() private router: Router,
    @Optional() @Inject('AppSettings') appSettings: any,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<QuickQuoteCardComponent>,
    @Inject(MAT_DIALOG_DATA) public passedSymbolValue: any
  ) {
    this.translationService.addTranslationFolder(
      '@pershing/nxi-ng-mod',
      'node_modules/@pershing/nxi-ng-mod/lib'
    );
    this.showFullQuote = this.authService.isEntitled('MOD_QUOTES_NEWS');
    this.isAdvisor = appSettings.isAdvisor;
    this.showRealTimeToggle =
      this.authService.isEntitled('REAL_TIME_EQUITY_QUOTES') && !this.isAdvisor;
    this.symbol = this.passedSymbolValue.symbol;
    this.invalidSymbol = this.passedSymbolValue.invalidSymbol;
    this.showQuickQuoteDialogUpdated(this.symbol);
    this.hasAgreed = this.quoteToggleService.hasSignedExchangeAgreement();
    this.displayTradeButton =
      this.authService.isEntitled('MUTUAL_FUND_TRADING') ||
      this.authService.isEntitled('STOCK_TRADING');
  }

  ngOnInit() {
    if (this.route) {
      this.route.queryParams.subscribe((param) => {
        this.queryParam = param;
      });
    }
    if (this.showRealTimeToggle) {
      this.QuickQuoteService.getUserPreference().subscribe((data) => {
        this.isRealTimePref = data;
        this.displayRealtime = this.isRealTimePref;
      });
    }
    this.dropdownTrigger();
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  toggleDisclaimers(): void {
    this.showDisclaimers = !this.showDisclaimers;
  }

  isShowingDisclaimers(): boolean {
    return this.showDisclaimers;
  }

  dropdownTrigger(): void {
    this.quoteToggleService.selectQuoteType$
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((quoteType) => {
        this.quoteType = quoteType;
        this.quoteData = null;
        if (this.quoteType == 'D') {
          this.getDelayedQuoteUpdated(this.symbol);
        } else {
          this.getRealTimeQuoteUpdated(this.symbol);
        }
      });
  }

  // @HostListener('document:realtimetoggle', ['$event'])
  // showAgreement(event: CustomEvent) {
  //   if(event.detail.toggleOn==='true'&&!this.hasAgreed)
  //   {
  //     this.showLink=true;
  //   }
  // }

  showQuickQuoteDialogUpdated(symbol: string) {
    this.showLink = false;
    this.quoteData = null;
    this.quoteType = this.quoteToggleService.getSelectedQuoteType(
      QuoteToggleService.QUICKQUOTE
    );
    if (this.quoteType == 'D') {
      this.getDelayedQuoteUpdated(symbol);
    } else {
      this.getRealTimeQuoteUpdated(symbol);
    }
  }
  getDelayedQuoteUpdated(symbol: string) {
    this.QuickQuoteService.getModSymbolData(symbol).subscribe((res: any) => {
      if (res && res[0]) {
        this.processQuoteData(res);
      } else {
        this.invalidSymbol = true;
      }
    });
  }
  getRealTimeQuoteUpdated(symbol: string) {
    this.QuickQuoteService.getRealTimeKey(symbol).subscribe((key) => {
      if (key && key.length > 0) {
        this.QuickQuoteService.getModSymbolDataRT(key[0]).subscribe(
          (res: any) => {
            if (res && res[0]) {
              this.processQuoteData(res);
            } else {
              this.getDelayedQuoteUpdated(symbol); // If real time quote is failing, go for delayed quote
            }
          }
        );
      } else {
        this.getDelayedQuoteUpdated(symbol);
      }
    });
  }

  onClose() {
    this.quoteData = null;
    this.invalidSymbol = false;
    this.chartImage = true;
  }
  // showQuickQuoteDialog(symbol: string) {
  //   this.showLink = false;
  //   this.quoteData = null;
  //   if (this.showRealTimeToggle && this.isRealTimePref) {
  //     this.getRealTimeQuote(symbol);
  //   } else {
  //     this.getDelayedQuote(symbol);
  //   }
  // }

  // getRealTimeQuote(symbol: string) {
  //   this.QuickQuoteService.getRealTimeKey(symbol).subscribe((key) => {
  //     if (key && key.length > 0) {
  //       this.QuickQuoteService.getModSymbolDataRT(key[0]).subscribe(
  //         (res: any) => {
  //           if (res && res[0]) {
  //             this.processQuoteData(res);
  //             const userPreference = this.QuickQuoteService.setUserPreference(true);
  //             lastValueFrom(userPreference);
  //             this.isRealTimePref = true;
  //             this.displayRealtime = this.isRealTimePref;
  //           } else {
  //             this.getDelayedQuote(symbol); // If real time quote is failing, go for delayed quote
  //           }
  //         }
  //       );
  //     } else {
  //       this.getDelayedQuote(symbol);
  //     }
  //   });
  // }
  // getDelayedQuote(symbol: string) {
  //   this.QuickQuoteService.getModSymbolData(symbol).subscribe((res: any) => {
  //     if (res && res[0]) {
  //       this.processQuoteData(res);
  //     } else {
  //       this.invalidSymbol = true;
  //     }
  //   });
  //   if (this.isRealTimePref) {
  //     const userPreference = this.QuickQuoteService.setUserPreference(true);
  //     lastValueFrom(userPreference);
  //     this.isRealTimePref = false;
  //     this.displayRealtime = this.isRealTimePref;
  //   }
  // }
  processQuoteData(res: any) {
    let data = res[0];
    if (data.Symbol) {
      this.quoteData = this.updateAsOfDate(data);
      this.symbol = data.Symbol;
      if (data.IssueType === 'MF') {
        this.fullQuoteUrl = '/nxi/research/quotenews/mutualfunds/mfsummary';
        this.tradeUrl = '/nxi/transact/neworder/mutualfundtrading';
      } else if (data.IssueType === 'ETF') {
        this.fullQuoteUrl = '/nxi/research/quotenews/etf/etfsummary';
        this.tradeUrl = '/nxi/transact/neworder/stocktrading';
      } else {
        this.fullQuoteUrl = '/nxi/research/quotenews/stocks/summary';
        this.tradeUrl = '/nxi/transact/neworder/stocktrading';
      }
    }
  }
  updateAsOfDate(data: any) {
    if (data.LastPriceTime && !!data.LastPriceTime) {
      let asOfDateArray = data.LastPriceTime.split(' ');
      if (this.isSysAndModDateSame(data.LastPriceTime)) {
        data.LastPriceTime =
          asOfDateArray[1] + ' ' + asOfDateArray[2] + ' ' + asOfDateArray[3];
      } else {
        data.LastPriceTime =
          asOfDateArray[1] +
          ' ' +
          asOfDateArray[2] +
          ' ' +
          asOfDateArray[3] +
          ' ' +
          asOfDateArray[0];
      }
    }
    return data;
  }
  isSysAndModDateSame(modLastPriceTime: string) {
    let dateFromModArray = modLastPriceTime.split(' ');
    let dateFromModInMsec = Date.parse(
      dateFromModArray[0] +
        ' ' +
        dateFromModArray[1] +
        ' ' +
        dateFromModArray[2]
    );
    let modDate = new Date(dateFromModInMsec);
    let sysDate = this.sysDate;
    // If either behind one another then it's not the same.
    return !(
      moment(sysDate).isAfter(modDate, 'day') ||
      moment(modDate).isAfter(sysDate, 'day')
    );
  }
  // toggleRealTime() {
  //   if (this.showRealTimeToggle && !this.isRealTimePref && this.symbol) {
  //     this.QuickQuoteService.getAgreementDetails().subscribe((data) => {
  //       if (data === 0) {
  //         this.hasAgreed = true;
  //         this.quoteData = null;
  //         this.getRealTimeQuote(this.symbol);
  //       } else if (data === 2) {
  //         this.isAdvisor = true; // invalid scenario as realtime toggle wont be shown to advisor
  //       } else {
  //         this.hasAgreed = false;
  //         this.showLink = true; // user not agreed to exchange agreement,
  //       }
  //     });
  //   } else if (this.isRealTimePref && this.symbol) {
  //     this.quoteData = null;
  //     this.getDelayedQuote(this.symbol);
  //   }
  // }
  tradeButtonNavigation(): void {
    this.quoteData = null;
    this.invalidSymbol = false;
    this.chartImage = true;
    this.dialogRef.close();
    this.redirect(this.getParamWithSymbol(), this.tradeUrl);
  }
  redirectToFullQuote() {
    this.quoteData = null;
    this.invalidSymbol = false;
    this.chartImage = true;
    this.dialogRef.close();
    this.redirect(this.getParamWithSymbol(), this.fullQuoteUrl);
  }
  redirectToExchangeAgreement() {
    this.invalidSymbol = false;
    this.chartImage = true;
    this.quoteData = null;
    this.appStore.put('EXCHANGE_AGREE_LASTPAGE', this.router.url.split('?')[0]);
    this.dialogRef.close();
    this.redirect(this.getParamWithSymbol(), '/nxi/exchangeagreementoverview');
  }
  getParamWithSymbol(): any {
    let param = this.queryParam
      ? JSON.parse(JSON.stringify(this.queryParam))
      : {};
    param.Symbol = this.symbol;
    return param;
  }
  redirect(param: any, url: string) {
    document.dispatchEvent(
      new CustomEvent('portal.gotoview', {
        detail: {
          gotoParams: param,
          gotoPage: url,
        },
      })
    );
  }
}
